import { getCookie } from "@/shared";

export const hasToken = () => {
    const jwt = getCookie("jwt");

    return jwt !== undefined && jwt !== null;
};
